import React from "react";

const ActionButtonGroup = (props) => {

    return (
        <div className="button-group small margin-0 align-right">
            {(props.children) && (
                props.children
            )}
        </div>
    )
}

export default ActionButtonGroup;
